import api from './api';
import types from './mutation-types';

export default {
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	async getPwaAppr_({ commit }) {
		try {
			const data = await api.getPwaAppr();
			if (data.header.code === 0) {
				//console.log('data', data);
				//const { claimInfo, pwaApcnScrId, clmApcnScrId } = data.body;
				const { claimInfo, pwaApcnScrId, clamRepayScrId, roApcnListScrId, rtnPartMstScrId } = data.body;
				//console.log('data.body1111', data.body);
				commit(types.DEFAULT_ASSIGN, { key: 'claimInfo', value: claimInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'pwaApcnScrId', value: pwaApcnScrId });
				//commit(types.DEFAULT_ASSIGN, { key: 'clmApcnScrId', value: clmApcnScrId });
				commit(types.DEFAULT_ASSIGN, { key: 'clamRepayScrId', value: clamRepayScrId });
				commit(types.DEFAULT_ASSIGN, { key: 'roApcnListScrId', value: roApcnListScrId });
				commit(types.DEFAULT_ASSIGN, { key: 'rtnPartMstScrId', value: rtnPartMstScrId });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	setClaimInfo_({ commit }, { key, value }) {
		commit(types.CLAIM_INFO, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	}
};
